import React, { useEffect } from "react";
import { Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import QuestionnaireStages from "./QuestionnaireStages";
import IssbContainer from "../../IssbContainer";
import useAirUserRoles from "../../../../utils/AuthUtils";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";
import { useSelector } from "react-redux";
import RoundList from "pages/ISSB/components/NavItems/RoundList";

/**
 * Configure Workflow Stages
 * @returns
 */
const IssbStageSetupPage = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "issb.stage.setup",
  });

  const roundSelector = useSelector((state) => state.issbRound);

  if (!roundSelector?.selectedRound) {
    return (
      <IssbContainer>
        <Text color="darkTeal" fontSize="body.m" my={4}>
          Please select a round
        </Text>
        <RoundList variant="secondary" />
      </IssbContainer>
    );
  }

  return (
    <IssbContainer>
      <Heading as="h2">
        <Text size="body.m" color="limeShade.700">
          {t("setup")}
        </Text>
        <Text variant="heading">{t("heading")}</Text>
      </Heading>
      <QuestionnaireStages />
    </IssbContainer>
  );
};

export default IssbStageSetupPage;
